import type { VisibilityMap } from "../../../../../../components/Questionnaire/validation/form/types";
import type {
  Answers,
  QuestionnaireState,
  UpdateAnswerPayload,
} from "../../../../types";
import {
  getPrimaryQuestionOptions,
  isPersonalisedCoverNo,
  isValidPersonalisedCoverValue,
} from "./personalisedCoverHelpers";
import { derivePersonalisedCoverNoUpdates } from "./derivePersonalisedCoverNoUpdates";
import { derivePersonalisedCoverShowUpdates } from "./derivePersonalisedCoverShowUpdates";

type ApplyPersonalisedCoverUpdatesArgs = {
  groupNames: string[];
  answers: Answers;
  visibility: VisibilityMap;
  serverVisibleByName: Record<string, boolean>;
  state: QuestionnaireState;
  questionName: string;
  value: UpdateAnswerPayload["value"];
};

export const applyPersonalisedCoverUpdates = ({
  groupNames,
  answers,
  visibility,
  serverVisibleByName,
  state,
  questionName,
  value,
}: ApplyPersonalisedCoverUpdatesArgs): {
  answers: Answers;
  visibility: VisibilityMap;
} => {
  // Get the valid option values for the primary question
  const options = getPrimaryQuestionOptions(state, questionName);

  // Check validity first - this is important because 'no' might be a valid option
  // We validate against the options array before checking if it's a "no" value
  const isValidValue = isValidPersonalisedCoverValue(value, options);

  if (!isValidValue) {
    // Value is not in options - don't show children (treat as invalid)
    return derivePersonalisedCoverNoUpdates({
      groupNames,
      answers,
      visibility,
    });
  } else if (isPersonalisedCoverNo(value)) {
    // Value is '0' or '' - hide children and delete answers
    return derivePersonalisedCoverNoUpdates({
      groupNames,
      answers,
      visibility,
    });
  } else {
    // Value is a valid non-zero option - show children
    return derivePersonalisedCoverShowUpdates({
      groupNames,
      answers,
      visibility,
      serverVisibleByName,
    });
  }
};
